import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-modal-panel',
  templateUrl: './modal-panel.component.html',
  styleUrls: ['./modal-panel.component.scss']
})
export class ModalPanelComponent implements OnInit, AfterViewInit {
  @Input() headerTitle: string;
  @Input() buttonTitle: string;
  @Input() allowSubmit = true;
  @Output() submit = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) {
  }

  ngAfterViewInit(): void {
    const firstControl = document.getElementsByClassName('form-control')[0];
    if (firstControl) {
      setTimeout(() => (firstControl as any).focus());
    }
  }

  ngOnInit() {
  }

  onSubmit() {
    this.submit.emit();
  }

  onClose() {
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal-panel/modal-panel.component.ts